/* Card Slider */
///////////////////////////////
///////////////////////////////
if (!customElements.get("card-slider")) {

  class CardSlider extends HTMLElement {
    constructor() {
        super();

        this.slidesContainer = this.querySelector(".card-slider__cards");  
        this.slides = this.querySelectorAll(".card-slider__cards div");  
        this.arrows = this.querySelectorAll(".card-slider__arrows button");
        this.nav = this.querySelectorAll(".card-slider__nav__items div");  
        this.init();
    }

    init() {
      this.flickity = new Flickity(this.slidesContainer, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.03,
        friction: 0.8,
        setGallerySize: true,
        percentPosition: false,
        imagesLoaded: true,
        cellAlign: "left"
      });

      this.nav.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.updateNav(item, i);
        });
      })

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
            this.nav.forEach((items) => {
                items.classList.remove("__active");
            })
            if (arrow.classList.contains("__basic-arrow__prev")) {
                this.flickity.previous(true);
            } else {
                this.flickity.next(true);
            }
            this.nav[this.flickity.selectedIndex].classList.add("__active");
            this.verticalScrollNav(this.nav[this.flickity.selectedIndex]);
        });
      })

      this.flickity.on('change', (index) => {
        this.updateNav(this.nav[index]);
        this.verticalScrollNav(this.nav[index]);
      })
    }

    updateNav(item, index) {
      this.nav.forEach((items) => {
        items.classList.remove("__active");
      })
      this.flickity.select(index); 
      item.classList.add("__active");

      this.verticalScrollNav(item);
    }

    verticalScrollNav(item) {
      item.parentElement.scrollTo({
        top: (item.offsetTop - item.offsetHeight),
        behavior: 'smooth'
      });
    }
  }
  
  customElements.define("card-slider", CardSlider);
}